import React from 'react';
import {
  Typography,
  Box,
  Stack,
  Skeleton,
} from '@mui/material';
import { PartnerStatus } from '@marageti/z4-sdk/lib/travel';
import {
  BackButton, ContextMenu, ContextMenuButton, ContextMenuItem,
} from '@marageti/z4-lib';
import { getFormattedPartnerCountries } from '../../utils/helpers';
import { StatusItemProps, ViewProps } from './types';
import { partnerStatusIcons } from '../status-icons';
import SubNavigation from '../sub-navigation';

const StatusItem = ({ onClick, status }: StatusItemProps) => (
  <ContextMenuItem onClick={() => onClick(status)}>
    <Stack spacing={1.5} direction="row">
      {partnerStatusIcons[status].icon}
      <Typography variant="h4">
        {partnerStatusIcons[status].displayName}
      </Typography>
    </Stack>
  </ContextMenuItem>
);

const PartnerSubNavigationView = ({
  contextMenuAnchor,
  contextMenuOpen,
  countryCodes = {},
  onClickNewStatus,
  setContextMenuAnchor,
  partner,
  tabs,
}: ViewProps) => {
  const countries = (partner && countryCodes) ? getFormattedPartnerCountries(partner, countryCodes) : undefined;
  return (
    <SubNavigation
      profile={{
        primary: partner ? (
          <Stack component="span" direction="row" alignItems="center" spacing={1}>
            <Typography
              component="span"
              variant="h3"
              fontWeight="bold"
            >
              {partner.name}
            </Typography>
            <Box
              component="span"
              display="flex"
            >
              {partner?.status && (
              <ContextMenuButton
                id="partner-status-context-button-id"
                onClick={(e) => setContextMenuAnchor(e.currentTarget)}
                open={contextMenuOpen}
                menuId="partner-status-context-button-menu-id"
                size="small"
              >
                {partnerStatusIcons[partner?.status].icon}
              </ContextMenuButton>
              )}
              <ContextMenu
                anchorEl={contextMenuAnchor}
                buttonId="partner-status-context-menu-button-id"
                id="partner-status-context-menu-id"
                onClose={() => setContextMenuAnchor(null)}
                open={contextMenuOpen}
              >
                { (Object.keys(PartnerStatus) as Array<keyof typeof PartnerStatus>).map((key) => (
                  <StatusItem
                    key={key}
                    onClick={onClickNewStatus}
                    status={key as PartnerStatus}
                  />
                ))}
              </ContextMenu>
            </Box>
          </Stack>
        ) : <Skeleton width={250} height={34} />,
        secondary: countries || <Skeleton width={150} />,
      }}
      startAdornment={(
        <BackButton
          aria-label="back to partners"
          defaultPath="/partners"
          edge="start"
        />
      )}
      tabs={tabs}
    />
  );
};

export default PartnerSubNavigationView;
